import { useCallback } from 'react';

import { useDialogs } from '@toolpad/core/useDialogs';

import PromoteConfirmationDialog from './PromoteConfirmation';
import { PromoteConfirmationDialogPayload } from './types';

function usePromoteConfirmation() {
  const dialogs = useDialogs();

  return useCallback(
    (payload: PromoteConfirmationDialogPayload) => dialogs.open(PromoteConfirmationDialog, payload),
    [dialogs],
  );
}

export { PromoteConfirmationDialog };
export default usePromoteConfirmation;
